/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_GymInputs */

const cs_enum_gym = /** @type {(inputs: Enum_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posilovna`)
};

const en_enum_gym = /** @type {(inputs: Enum_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym`)
};

/**
* | output |
* | --- |
* | "Gym" |
*
* @param {Enum_GymInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_gym = /** @type {((inputs?: Enum_GymInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_GymInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_gym(inputs)
	return cs_enum_gym(inputs)
});